import { IGaugesNotificationData } from '../services/GaugesNotificationService';
import { ProductTypes } from '../main/constants/ProductTypes';
import { ActiveProduct } from './ActiveProduct';

export class GaugesNotifications {
    static REQUIRED_NOTIFICATIONS = [50, 75];
    private _type: ProductTypes;
    private _displayedNotifications: number[] = [];
    private _pendingNotification: number | null;

    constructor(product: ActiveProduct, notificationData: IGaugesNotificationData) {
        this._type = product.type;
        this._pendingNotification = this.getPendingNotification(product, notificationData);
    }

    get pendingNotification(): number | null {
        return this._pendingNotification;
    }

    get type(): ProductTypes {
        return this._type;
    }

    public closeNotification() {
        if (this._pendingNotification) {
            this._displayedNotifications.push(this._pendingNotification);
            this._pendingNotification = null;
        }
    }

    public serialize(): IGaugesNotificationData {
        return {
            type: this._type,
            notifications: this._displayedNotifications,
        };
    }

    private getPendingNotification(product: ActiveProduct, notificationData: IGaugesNotificationData): number | null {
        const percentUsedCredits = Math.trunc((product.usedCredits * 100) / product.quantity);

        let notificationPercent;
        let lastNotificationShow = this.getBiggestNotification(notificationData);
        let pendingNotificationPercent = null;

        for (notificationPercent of GaugesNotifications.REQUIRED_NOTIFICATIONS) {
            const requireShowNotification = percentUsedCredits > notificationPercent;
            const notificationDisplayed = notificationData.notifications.includes(notificationPercent);
            const hasHigNotification =
                !notificationDisplayed && requireShowNotification && notificationPercent > lastNotificationShow;

            if (hasHigNotification) pendingNotificationPercent = notificationPercent;
        }

        return pendingNotificationPercent;
    }

    private getBiggestNotification(notificationData: IGaugesNotificationData) {
        let biggestValue = 0;
        let notificationValue;

        for (notificationValue of notificationData.notifications) {
            if (notificationValue > biggestValue) biggestValue = notificationValue;
        }

        return biggestValue;
    }
}
